<template>
  <div class="container left-right-page"  >
    <component :is="style">
      .pagination.pagination-primary .page-item.active > .page-link, 
      .pagination.pagination-primary .page-item.active > .page-link:focus, 
      .pagination.pagination-primary .page-item.active > .page-link:hover
      {
        background-color: {{myTheme.customizeButton.backgroundColor}};
        color: {{ myTheme.customizeButton.color }};
      }
      .el-collapse-item__header.is-active{
        color: {{ myTheme.primaryTextColor }};
      }
    </component>
    <header class="blur"></header>
    <main>
      <div class="row">
       <left-location-details v-if="selectedLocation" :selectedLocation="selectedLocation" :locationStatus="locationStatus"></left-location-details>
        <div class="right" :class="{'col-lg-8' : selectedLocation , 'col-lg-12' : !selectedLocation }" >
          <previous-orders></previous-orders>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import {PreviousOrders} from "@/views";
import {LeftLocationDetails, EmptyData} from "@/views/components";
import { helpers } from "@/utilities";
export default {
  name: "re-order",
  bodyClass: "reviews-page",
  computed: {
    locationStatus: function() {
      return helpers.canMakeOrder(this.selectedLocation, this.isMounted);
    }
  },
  components: {
    PreviousOrders,
    LeftLocationDetails,  
    EmptyData
  },
  data() {
    return {
      isMounted : false,
      style : "style"
    };
  },
  mounted(){
    this.isMounted = true;
  }
};
</script>
<style scoped>
.container {
  max-width: 1250px;
  margin: -3px auto 30px;
  padding: 0 !important;
  width: 90%;
  background-color: #fff;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.1);
}
header {
  background: #eee;
  background-image: url("~/img/header-blur.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: 250px;
}

header i {
  position: relative;
  cursor: pointer;
  right: -96%;
  top: 25px;
  font-size: 18px !important;
  color: #fff;
}

@media (max-width: 800px) {
  header {
    height: 150px;
  }

  header i {
    right: -90%;
  }
}
main {
  padding: 20px 20px 0px 20px;
}


.nav-tabs > .nav-item > .nav-link {
  padding: 10px 13px;
}
.nav-tabs {
  border: 0;
  padding: 15px 0 !important;
}
</style>
